const listAttributes = ['courseId', 'subject', 'label', 'shortLabel', 'grade'] as const;

// The billing values are read, never written: a course state no class governs is priced by
// them, and nothing else is
const getAttributes = [...listAttributes, 'terms', 'creditsPerTerm', 'xeroCodes'] as const;

const updateAttributes = ['label', 'shortLabel'] as const;

export const CourseAttributes = {
  List: listAttributes,
  Get: getAttributes,
  Update: updateAttributes,
};
